<template>
  <div>
    <TabelaAtualizacao/>
  </div>
</template>

<script>
import TabelaAtualizacao from './Shared/TabelaAtualizacao'

export default {
  components: {
    TabelaAtualizacao
  }
}
</script>

<style>
</style>
